<template>
  <!-- 
    컴포넌트 설명: 다양한 스타일과 크기를 지원하는 공통 버튼 컴포넌트입니다.
    기능: 
    - variant: 버튼의 색상 스타일 (primary, secondary, outline)
    - size: 버튼의 크기 (sm, md, lg)
    - block: 너비를 100%로 채울지 여부
    - justify: 버튼 내부 텍스트 정렬 (start, end)
    - disabled: 비활성화 상태 여부
  -->
  <button
    type="button"
    class="btn-item"
    :class="[
      variant ? `btn-${variant}` : 'btn-primary', // 기본값은 primary
      size ? `btn-${size}` : '',                 // 크기 클래스 추가
      { 'btn-block': block },                    // 블록 버튼 여부
      justify ? `justify-${justify}` : '',        // 텍스트 정렬 클래스 추가
      qrType ? `tp-${qrType}` : '',      // qr버튼 타입
      arrow ? `btn-arrow` : ''      // qr버튼 타입
    ]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <!-- 버튼 내부에 들어갈 텍스트나 아이콘을 위한 슬롯 -->
    <span v-if="qrType">출입QR코드</span>
    <template v-if="text">{{ text }}</template>
    <slot v-else></slot>
  </button>
</template>

<script setup>
/**
 * @desc 공통 버튼 컴포넌트 (BaseButton)
 * 사용자가 정의한 SCSS 클래스를 기반으로 동작하며, 유연한 스타일 적용을 지원합니다.
 */

// 컴포넌트가 외부로부터 받을 속성(Props)들을 정의합니다.
const props = defineProps({
  // 버튼 스타일: 'primary', 'secondary', 'outline' 등
  variant: { type: String, default: 'primary'},
  // 버튼 크기: 'sm', 'md', 'lg'
  size: { type: String, default: '' },
  // 너비를 100%로 설정할지 여부
  block: { type: Boolean, default: false },
  // 텍스트 정렬: 'start', 'end' (기본값은 중앙 정렬)
  qrType: { type: String, default: '' },
  // 버튼 비활성화 상태
  disabled: { type: Boolean, default: false },
  // 버튼 정렬
  justify : { type:String, default: '' },
  // prop으로 버튼의 텍스트를 받을떄 사용
  arrow:{ type: Boolean, default: false },
  text: {
    type: String,
    default: ''
  },
})

// 클릭 이벤트를 부모 컴포넌트로 전달할 수 있도록 정의합니다.
defineEmits(['click'])
</script>
